export enum Type {
    Commit = 'commit',
    Branch = 'branch',
    Tag = 'tag',
}